export const environment = {
  production: false,
  apiUrl: 'https://api-test.keremetsolution.kz/api'
};
